import React from 'react';
import { FictionalIcon } from '../../customFrontend/parts';
import { ChatappHomeCopy, ChatappLabels } from '../../siteBrands/chatapp/types';

const IMAGES = '/images/sites/chatapp';

/** chatapp.net's home page copy, standard German with informal "du". Written for Germany, not translated. */
export const HOME: ChatappHomeCopy = {
  eyebrow: 'Erotikchat für Erwachsene',
  h1: 'Sexchat, der Spaß macht:',
  h1Accent: 'flirten, wann und wo du willst',
  lead: 'Chatapp ist der Flirtchat für Erwachsene, die gern mit Worten spielen. Du meldest dich kostenlos an, schreibst deine ersten Nachrichten gratis und bestimmst selbst, wie heiß es wird.',
  cta: 'Kostenlos anmelden',
  notifications: [
    { title: 'Anmeldung kostenlos', text: 'Ohne Kreditkarte, nur mit einem Nickname.' },
    { title: 'Erste Nachrichten gratis', text: 'Probier in Ruhe aus, ob dir der Chat gefällt.' },
    { title: 'Privat bleibt privat', text: 'Name und E-Mail-Adresse sieht niemand.' },
  ],
  about: {
    title: 'Was ist Chatapp?',
    paragraphs: [
      <>
        Chatapp ist ein Sexchat und Flirtchat für Erwachsene in Deutschland, der im Browser deines Handys genauso
        läuft wie am Laptop. Unter einem Nickname stöberst du durch Profile, schickst Nachrichten, Flirts und Fotos
        und spielst Match: Profile ansehen, nach links oder rechts wischen, weiterschreiben. Ob du lieber mit Frauen
        oder mit Männern chattest, im Mittelpunkt stehen die Worte, das Kribbeln vor der nächsten Antwort und dein
        eigenes Tempo.
      </>,
      <>
        Chatapp ist Unterhaltung, keine Partnerbörse. Wir nutzen fiktive Profile, deren Ziel es ist, mit dir zu
        flirten. Du erkennst sie an einem Personensymbol <FictionalIcon language="de" />, und physischer Kontakt mit
        diesen Profilen ist nicht möglich. Was du bekommst, ist ein prickelndes Gespräch, wann immer dir danach ist.
      </>,
    ],
  },
  steps: {
    title: 'So startest du in deinen ersten Chat',
    items: [
      { title: 'Nickname wählen', text: 'Leg fest, mit wem du schreiben möchtest, und such dir einen Namen aus. Das dauert eine Minute und kostet nichts.' },
      { title: 'Gratis losschreiben', text: 'Deine ersten Nachrichten kosten dich nichts. Schick einen Flirt, schau, was zurückkommt, und entscheide dann, ob du weitermachst.' },
      { title: 'Mit Credits weiterchatten', text: 'Nach den Gratisnachrichten kosten Nachrichten, Flirts und Fotos Credits. Ein Paket kaufst du nur, wenn du möchtest, und jeden Preis siehst du vorher.' },
    ],
    image: {
      src: `${IMAGES}/6598229-960.webp`,
      srcSet: `${IMAGES}/6598229-480.webp 480w, ${IMAGES}/6598229-960.webp 960w`,
      sizes: '(min-width: 992px) 32vw, (min-width: 576px) 24rem, 100vw',
      width: 960,
      height: 1200,
      alt: 'Lächelnde Frau liegt in einem blau beleuchteten Schlafzimmer im Bett und schaut auf ihr Smartphone',
    },
  },
  reasons: {
    title: 'Warum Chatapp?',
    items: [
      { title: 'Gespräche mit Prickeln', text: 'Hier zählt das Schreiben: eine freche Frage, eine zweideutige Antwort, und schon ist der Abend nicht mehr langweilig.' },
      { title: 'Rund um die Uhr', text: 'In der S-Bahn, in der Mittagspause oder spät nachts im Bett: Der Chat ist immer offen und braucht keine App.' },
      { title: 'Diskret', text: 'Du chattest unter einem Nickname. Name und E-Mail-Adresse bleiben bei uns, und in deinen sozialen Netzwerken taucht nichts auf.' },
      { title: 'Fair und klar', text: 'Nur für Erwachsene ab 18, alle Preise vorab sichtbar und fiktive Profile mit einem Personensymbol gekennzeichnet.' },
    ],
  },
  cities: {
    title: 'Sexchat in deiner Stadt',
    intro: 'Von der Spree bis an den Rhein, von der Elbe bis an die Isar: Such dir deine Stadt aus.',
  },
  faq: {
    title: 'Häufige Fragen zu Chatapp',
    items: [
      {
        q: 'Ist Chatapp kostenlos?',
        a: <p>Die Anmeldung kostet nichts, und deine ersten Nachrichten sind ebenfalls gratis. Danach brauchst du Credits für Nachrichten, Flirts und Fotos. Credits kaufst du nur, wenn du weiterschreiben willst, und den Preis siehst du immer vor dem Bezahlen.</p>,
      },
      {
        q: 'Brauche ich für die Anmeldung eine Kreditkarte?',
        a: <p>Nein. Bei der Anmeldung fragen wir nie nach einer Kreditkarte. Du wählst einen Nickname und kannst sofort loslegen.</p>,
      },
      {
        q: 'Sind die Profile echt?',
        a: <p>Nein. Chatapp nutzt fiktive Profile, deren Ziel es ist, mit Nutzern zu flirten. Du erkennst sie am Personensymbol <FictionalIcon language="de" /> in ihrem Profil, und physischer Kontakt mit diesen Profilen ist nicht möglich.</p>,
      },
      {
        q: 'Kann ich über Chatapp jemanden treffen?',
        a: <p>Chatapp ist ein Chat zur Unterhaltung. Verabredungen oder Dates sind nicht vorgesehen, und weil die Profile fiktiv sind, ist ein Treffen nicht möglich.</p>,
      },
      {
        q: 'Bekommt jemand mit, dass ich Chatapp nutze?',
        a: <p>Nur wenn du es selbst erzählst. Andere sehen deinen Nickname, nie deinen Namen oder deine E-Mail-Adresse. In sozialen Netzwerken erscheint nichts, und welche E-Mail-Benachrichtigungen du bekommst, legst du selbst fest.</p>,
      },
      {
        q: 'Ab welchem Alter darf ich mitmachen?',
        a: <p>Chatapp ist nur für Erwachsene. Du musst mindestens 18 Jahre alt sein, um ein Profil anzulegen.</p>,
      },
    ],
  },
  final: {
    title: 'Lust auf einen Flirt heute Abend?',
    text: 'Dein Profil steht in einer Minute, und die ersten Nachrichten kosten dich nichts.',
    button: 'Jetzt gratis starten',
  },
};

export const LABELS: ChatappLabels = {
  cityLinkKind: 'Sexchat',
  now: 'jetzt',
  citiesNav: 'Sexchat nach Stadt',
  moreCities: 'Sexchat in anderen Städten',
  cityFaqTitle: (city) => `Fragen zum Chatten in ${city}`,
  backHome: 'Zurück zu Chatapp: Sexchat und Flirtchat',
  footerHome: 'Sexchat und Flirtchat',
  footerNav: 'Chatapp in Deutschland',
};
